import React, { useState, useEffect } from 'react';

import { toast } from "react-toastify";
import { BsFillCheckCircleFill } from 'react-icons/bs';

import PhoneInput from '../SignUpCompletionFormComponents/inputs/PhoneInput';
import styles from '../SignUpCompletionFormComponents/Form.module.css';
import MiniLoader from '../ui/Visual-utilities/MiniLoader';

import { doc, updateDoc } from 'firebase/firestore';
import { RecaptchaVerifier, PhoneAuthProvider, linkWithCredential } from "firebase/auth";
import { auth, db } from '../../firebase';


export default function () {
    const [phone, setPhone] = useState('');
    const [smsCode, setSmsCode] = useState('');
    const [verificationId, setVerificationId] = useState(null);
    const [error, setError] = useState('');

    const [codeLoad, setCodeLoad] = useState(false);
    const [verifyLoad, setVerifyLoad] = useState(false);

    const sendCode = () => {
        setCodeLoad(true);
        if (!verificationId) { //first time
            generateRecaptcha();
        } else {
            regenerateRecaptcha();
        }

        const appVerifier = window.recaptchaVerifier;
        const phoneNumber = '+961 ' + phone.replace(/\D/g, '');
        console.log("phone: ", phoneNumber);

        const phoneAuthProvider = new PhoneAuthProvider(auth);
        phoneAuthProvider.verifyPhoneNumber(phoneNumber, appVerifier)
            .then((result) => {
                console.log("sms sent: ", result);
                toast("SMS Code sent")
                setVerificationId(result);
                setCodeLoad(false);
            }).catch((error) => {
                if (error.code === "auth/too-many-requests") {
                    setError("Too many requests. Please try again later.");
                } else {
                    window.location.reload();
                }
                console.log("erroor:", error);
            });
    }

    const regenerateRecaptcha = () => {
        if (!window.recaptchaVerifier) {

            window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
                'size': 'invisible',
                'callback': (response) => {
                    // reCAPTCHA solved, allow signInWithPhoneNumber.
                    console.log("recaptcha: ", response);
                },
                'expired-callback': () => {
                    console.log('reCAPTCHA expired');
                }
            }, auth);
        } else {
            // re-render recaptchaVerifier
            window.recaptchaVerifier.render();
        }
    }

    const generateRecaptcha = () => {
        window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': (response) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                console.log("recaptcha: ", response);
            },
            'expired-callback': () => {
                console.log('reCAPTCHA expired');
            }
        }, auth);
    }


    const verifyCode = async () => {
        const usersRef = doc(db, "users", auth.currentUser?.uid);
        setVerifyLoad(true);

        // Ask user for the verification code. Then:
        const cred = PhoneAuthProvider.credential(verificationId, smsCode);
        const user = auth.currentUser;

        await linkWithCredential(user, cred)
            .then(async (result) => {
                console.log("true sms code: ", result);
                await updateDoc(usersRef, {
                    phone: phone
                })
                    .then(() => {
                        setVerifyLoad(false);
                        console.log("phone updated");
                        toast.success("Phone verified!")
                    })
                    .catch((e) => {
                        setVerifyLoad(false);
                        console.log("phone not updated ", e);
                    })
            })
            .catch((e) => {
                console.log(e);
                setVerifyLoad(false);
                if (e.code === "auth/account-exists-with-different-credential") {
                    setError("This phone number is already associated with another account.");
                } else {
                    setError("False SMS Code.");
                }
            });

    }



    return (
        <div style={{ width: "auto", height: "auto", background: 'white', position: 'fixed', top: '0', bottom: '0', left: '0', right: '0' }}>
            <div className={styles.form}
                style={{
                    position: 'absolute',
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)"
                }}>
                <div className={styles.formContainer}>
                    <div className={styles.subFormContainer}>
                        <div className={styles.header}>
                            <h4>Phone Verification</h4>
                        </div>
                        <div className={styles.singleFormInputContainer}>
                            <div className={styles.checkedInput}
                                style={{ color: phone.length !== 10 ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
                            <div className={styles.singleFormInput}>
                                <div className={styles.singleInputTitle}>
                                    Enter a valid phone number
                                </div>
                                <b>+961</b>

                                <PhoneInput
                                    value={phone}
                                    onChangeValue={(val) => {
                                        setPhone(val);
                                        console.log()

                                    }}
                                />
                            </div>
                        </div>
                        <button className={styles.verifyButton} onClick={() => sendCode()} disabled={phone?.length !== 10}> {(codeLoad ? <MiniLoader /> : !verificationId ? 'Send code' : 'Resend code')}</button>

                        {verificationId &&
                            <div>
                                <div className={styles.singleFormInputContainer}>
                                    <div className={styles.checkedInput}
                                        style={{ color: smsCode.length !== 6 ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
                                    <div className={styles.singleFormInput}>
                                        <div className={styles.singleInputTitle}>
                                            Send code
                                        </div>
                                        <input
                                            maxLength={6}
                                            max={6}
                                            type="number"
                                            placeholder="Sms code"
                                            value={smsCode}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 6)
                                                    setSmsCode(e.target.value);
                                            }}
                                        />
                                        <b>{`${smsCode?.length}/6`}</b>
                                    </div>
                                </div>
                                <p className={styles.falseTxt}>{error}</p>

                                <button className={styles.verifyButton} onClick={() => verifyCode()} disabled={smsCode?.length !== 6}>{verifyLoad ? <MiniLoader /> : "Verify code"}</button>

                            </div>
                        }
                        <div id='recaptcha-container'></div>
                    </div>

                </div>
            </div>
        </div>
    )
}
